export interface LeadScenario {
  downPayment: string
  estimatedPayment: string
  creditRange: string
  timeline: string
  propertyType: string
  coBorrower: string
  notes: string
}

export interface LeadTask {
  id: string
  label: string
  due: string
  urgent?: boolean
}

export const leadScenarios: Record<string, LeadScenario> = {
  'L-40219': {
    downPayment: '10% · $48,500',
    estimatedPayment: '$3,180 / mo (PITI est.)',
    creditRange: '740–759 (self-reported)',
    timeline: 'Making offers in 30 days',
    propertyType: 'Single family — primary residence',
    coBorrower: 'None',
    notes: 'Wants to compare conventional vs. 2-1 buydown before touring again.',
  },
  'L-40214': {
    downPayment: '20% · $122,500',
    estimatedPayment: '$3,940 / mo (PITI est.)',
    creditRange: '780+ (self-reported)',
    timeline: 'Under contract within 45 days',
    propertyType: 'Single family — primary residence',
    coBorrower: 'Anand Raman',
    notes: 'Referred by Dana Whitfield. Needs a jumbo pre-approval letter for showings.',
  },
  'L-40208': {
    downPayment: 'N/A — refinance',
    estimatedPayment: '$2,120 / mo (PITI est.)',
    creditRange: '700–719 (self-reported)',
    timeline: 'Rate driven — will act under 6%',
    propertyType: 'Single family — primary residence',
    coBorrower: 'None',
    notes: 'Current rate 7.125%. FHA streamline avoids a new appraisal.',
  },
  'L-40201': {
    downPayment: '0% · VA entitlement',
    estimatedPayment: '$2,610 / mo (PITI est.)',
    creditRange: '720–739 (self-reported)',
    timeline: 'Touring homes now',
    propertyType: 'Single family — primary residence',
    coBorrower: 'Marco Serrano',
    notes: 'First-time VA buyers. Needs COE walkthrough.',
  },
  'L-40188': {
    downPayment: '15% · $60,300',
    estimatedPayment: '$2,690 / mo (PITI est.)',
    creditRange: '760–779 (self-reported)',
    timeline: 'Offer accepted pending pre-approval',
    propertyType: 'Townhome — primary residence',
    coBorrower: 'None',
    notes: 'Comparing a 2-1 buydown against a permanent rate buy-down.',
  },
  'L-40176': {
    downPayment: '10% · $53,890',
    estimatedPayment: '$3,520 / mo (PITI est.)',
    creditRange: '740–759 (self-reported)',
    timeline: 'Making offers in 30 days',
    propertyType: 'Single family — primary residence',
    coBorrower: 'None',
    notes: 'Referred by Renee Ortiz. Asked about float-down policy on a 45-day lock.',
  },
  'L-40154': {
    downPayment: '20% · $147,000',
    estimatedPayment: '$3,860 / mo (PITI est.)',
    creditRange: '780+ (self-reported)',
    timeline: 'Application in progress',
    propertyType: 'Single family — primary residence',
    coBorrower: 'Lily Nguyen',
    notes: 'Application walkthrough complete. Awaiting pay stubs and bank statements.',
  },
  'L-40131': {
    downPayment: 'N/A — refinance',
    estimatedPayment: '$1,780 / mo (PITI est.)',
    creditRange: '700–719 (self-reported)',
    timeline: 'Watching rates — no urgency',
    propertyType: 'Condo — primary residence',
    coBorrower: 'None',
    notes: 'Cash-out interest for a kitchen remodel if rates drop below 6.25%.',
  },
  'L-40117': {
    downPayment: '3.5% · $12,425',
    estimatedPayment: '$2,410 / mo (PITI est.)',
    creditRange: '660–679 (self-reported)',
    timeline: 'Paused until spring',
    propertyType: 'Single family — primary residence',
    coBorrower: 'None',
    notes: 'Working on credit. Re-engage with an FHA payment scenario in 60 days.',
  },
}

export const leadTasks: Record<string, LeadTask[]> = {
  'L-40219': [
    {
      id: 'T-9950',
      label: 'Make first contact — SLA expires in 5 minutes',
      due: 'Due 10:00 AM',
      urgent: true,
    },
  ],
  'L-40214': [
    { id: 'T-9955', label: 'Send jumbo pre-approval letter', due: 'Due today' },
  ],
  'L-40188': [
    {
      id: 'T-9946',
      label: 'Send both buydown payment scenarios',
      due: 'Due today',
    },
  ],
  'L-40154': [
    { id: 'T-9944', label: 'Collect pay stubs and bank statements', due: 'Due tomorrow' },
  ],
}
